import React, { useState, useEffect } from 'react';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { toast } from 'react-toastify';
import ApiBaseURL from '../ApiBaseUrl/ApiBaseURL';
import { useNavigate } from 'react-router-dom';

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const DashboardByVehicleUtlization = ({
    vehicleTypeId = null,
    vendorId = null,
    driverId = null,
    vehicleId = null,
    // period = '3m'
    period = null
}) => {
    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedRange, setSelectedRange] = useState(period);
    const [chartData, setChartData] = useState({
        utilizedVehicles: 0,
        notUtilizedVehicles: 0
    });

    const navigate = useNavigate();

    const handleGetVehicleUtlization = async () => {
        const userId = localStorage.getItem('userId');
        const token = localStorage.getItem('token');

        if (!userId || !token) {
            toast.error('Missing userId or token in localStorage');
            return;
        }

        try {
            const resp = await fetch(`${ApiBaseURL}/dashboard/v1/get/vehicle-utilization`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    userId,
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    vehicleTypeId,
                    vendorId,
                    driverId,
                    vehicleId,
                    // period: selectedRange.toLowerCase()
                    period
                })
            });

            const result = await resp.json();
            if (resp.ok && result.statusDescription.statusCode === 200) {
                setChartData(result.data[0] || {});
            } else if ([401, 403].includes(result.statusDescription.statusCode)) {
                toast.error(result.statusDescription.description || "Unauthorized access. Redirecting...");
                localStorage.clear();

                setTimeout(() => {
                    window.location.replace('/');
                }, 1500);
            } else {
                console.log(result.statusDescription.description || 'Failed to fetch fuel data');
            }
        } catch (err) {
            toast.error('Error fetching fuel summary: ' + err.message);
        }
    };

    useEffect(() => {
        handleGetVehicleUtlization();
    }, [vehicleTypeId, vendorId, driverId, vehicleId, selectedRange, period]);

    const handleFilterSelect = (range) => {
        setSelectedRange(range);
        setShowDropdown(false);
    };

    const data = {
        labels: ['Utilization', 'Un-Utilization'],
        datasets: [
            {
                label: 'Vehicle Utilization',
                // data: [
                //     chartData.totalFuel || 0,
                //     chartData.totalAmount || 0
                // ],
                data: [
                    Math.round(chartData.utilizedVehicles ?? 0),
                    Math.round(chartData.notUtilizedVehicles ?? 0)
                ],
                backgroundColor: [
                    'rgba(75, 192, 192, 0.7)',
                    'rgba(255, 99, 132, 0.7)',
                ],
                borderColor: [
                    'rgba(75, 192, 192, 1)',
                    'rgba(255, 99, 132, 1)',
                ],
                borderWidth: 1,
            }
        ]
    };

    // const options = {
    //     responsive: true,
    //     cutout: '80%',
    //     plugins: {
    //         legend: {
    //             position: 'bottom',
    //             labels: {
    //                 boxWidth: 20,
    //                 padding: 15,
    //             },
    //         }
    //     }
    // };

    const options = {
        responsive: true,
        cutout: '60%',
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 20,
                    padding: 15,
                },
            },
            datalabels: {
                color: '#000',
                formatter: (value, context) => {
                    const dataset = context.chart.data.datasets[0].data;
                    const total = dataset.reduce((acc, val) => acc + val, 0);
                    const percentage = ((value / total) * 100).toFixed(1) + '%';
                    return percentage;
                },
                font: {
                    weight: 'bold',
                    size: 10
                }
            }
        }
    };

    const filterOptions = ['Today', 'Yesterday', 'Week', '1M', '3M', '6M'];

    return (
        // <div className="row g-">
        <div className="card shadow-sm" style={{ maxWidth: '400px' }}>
            <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="card-title mb-0">Vehicle Utilization</h5>
                    <div style={{ position: 'relative' }}>
                        <i
                            className="fa-solid fa-filter d-none"
                            style={{ cursor: 'pointer', fontSize: '16px' }}
                            onClick={() => setShowDropdown(!showDropdown)}
                        ></i>
                        {showDropdown && (
                            <div
                                className="dropdown-menu show"
                                style={{ position: 'absolute', right: 0, zIndex: 999 }}
                            >
                                {filterOptions.map((range) => (
                                    <button
                                        key={range}
                                        className="dropdown-item"
                                        onClick={() => handleFilterSelect(range)}
                                    >
                                        {range}
                                    </button>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
                <div style={{ height: '280px', width: '280px' }}>
                    <Doughnut data={data} options={options} />
                </div>
            </div>
        </div>
        // </div>
    );
};

export default DashboardByVehicleUtlization;